/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UserAvvService {
    /**
     * Download AVV PDF for current user
     * @returns binary AVV PDF file
     * @throws ApiError
     */
    public static getAppUserAvvDownload(): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/user/avv',
            errors: {
                400: `Error`,
            },
        });
    }
    /**
     * Accept AVV (set accepted date)
     * @returns any AVV accepted successfully
     * @throws ApiError
     */
    public static postAppUserAvvAccept(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/user/avv',
            errors: {
                400: `Error`,
            },
        });
    }
    /**
     * Get AVV accepted date
     * @returns any AVV accepted date
     * @throws ApiError
     */
    public static getAppUserAvvAcceptedDate(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/user/avv/accepted-date',
            errors: {
                400: `Error`,
            },
        });
    }
}
